import { isBrowser } from "appConfiguration";
import { trace } from "@opentelemetry/api";

export type ExceptionTelemetry = {
  exception: Error;
  properties?: { [key: string]: any };
  severity?: "Critical" | "Error" | "Warning" | "Information" | "Trace";
} & { [key: string]: any };

export function trackServerException(telemetry: ExceptionTelemetry) {
  if (process.env.NODE_ENV === "test") {
    return;
  }
  if (isBrowser) {
    console.error(
      "this function should not be cannot be called from the client side"
    );
    return;
  }
  if (process.env.NEXT_RUNTIME === "nodejs") {
    const span = trace.getActiveSpan();
    if (
      telemetry.exception instanceof Error ||
      typeof telemetry.exception === "string"
    ) {
      span?.recordException(telemetry.exception);
    }
    span?.addEvent("exception", {
      ...telemetry.properties,
      severity: telemetry.severity,
    });
  }
}
